import dictMixin from './dict-mixin';
const mixins = [
    dictMixin,
]

export default (Vue) => {
    Vue.mixin({ mixins });
}